import { render, staticRenderFns } from "./PartsAdmin.vue?vue&type=template&id=3aaa6378"
import script from "./PartsAdmin.vue?vue&type=script&lang=js"
export * from "./PartsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports